module.exports = {
	title:'首页'
}


// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/modules/home.js